export type DYTailwindColorSet = 'slate' | 'gray' | 'zinc' | 'neutral' | 'stone' | 'red' | 'orange' | 'amber' | 'yellow' | 'lime' | 'green' | 'emerald' | 'teal' | 'cyan' | 'sky' | 'blue' | 'indigo' | 'violet' | 'purple' | 'fuchsia' | 'pink' | 'rose'

export function useDYTailwindUtil() {
  /**
   * Tailwind CSS에 적용되는 백그라운드 컬러 클래스 생성 메서드. 주어진 색상에 해당하는 라이트/다크 모드용 클래스를 반환함.
   * 
   * @param color 
   * @returns 
   */
  const makeBgColorClasses = (color: DYTailwindColorSet) => {
    const classes: string[] = []
    switch (color) {
      case 'slate': classes.push('!bg-slate-100', 'dark:!bg-slate-900'); break;
      case 'gray': classes.push('!bg-gray-100', 'dark:!bg-gray-900'); break;
      case 'zinc': classes.push('!bg-zinc-100', 'dark:!bg-zinc-900'); break;
      case 'neutral': classes.push('!bg-neutral-100', 'dark:!bg-neutral-900'); break;
      case 'stone': classes.push('!bg-stone-100', 'dark:!bg-stone-900'); break;
      case 'red': classes.push('!bg-red-100', 'dark:!bg-red-900'); break;
      case 'orange': classes.push('!bg-orange-100', 'dark:!bg-orange-900'); break;
      case 'amber': classes.push('!bg-amber-100', 'dark:!bg-amber-900'); break;
      case 'yellow': classes.push('!bg-yellow-100', 'dark:!bg-yellow-900'); break;
      case 'lime': classes.push('!bg-lime-100', 'dark:!bg-lime-900'); break;
      case 'green': classes.push('!bg-green-100', 'dark:!bg-green-900'); break;
      case 'emerald': classes.push('!bg-emerald-100', 'dark:!bg-emerald-900'); break;
      case 'teal': classes.push('!bg-teal-100', 'dark:!bg-teal-900'); break;
      case 'cyan': classes.push('!bg-cyan-100', 'dark:!bg-cyan-900'); break;
      case 'sky': classes.push('!bg-sky-100', 'dark:!bg-sky-900'); break;
      case 'blue': classes.push('!bg-blue-100', 'dark:!bg-blue-900'); break;
      case 'indigo': classes.push('!bg-indigo-100', 'dark:!bg-indigo-900'); break;
      case 'violet': classes.push('!bg-violet-100', 'dark:!bg-violet-900'); break;
      case 'purple': classes.push('!bg-purple-100', 'dark:!bg-purple-900'); break;
      case 'fuchsia': classes.push('!bg-fuchsia-100', 'dark:!bg-fuchsia-900'); break;
      case 'pink': classes.push('!bg-pink-100', 'dark:!bg-pink-900'); break;
      case 'rose': classes.push('!bg-rose-100', 'dark:!bg-rose-900'); break;
    }
    return classes
  }

  return {
    makeBgColorClasses
  }
}